// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__J5mTs","range":"MonthRangeSwitch_range__178-9","disabled":"MonthRangeSwitch_disabled__2qTkb"};